import React from 'react';

const FeatureContentElements = ({
  type = 'text', // Content type: 'heading', 'subheading', 'list', 'paragraph', etc.
  content, // Content to display (string or array for lists)
  className = '', // Additional class names
  theme = 'dark', // Theme: 'dark' or 'light'
  container = false,
  children
}) => {
  // Style objects for light and dark themes
  const stylesLight = {
    mainContainer: 'border text-gray-900 border-gray-500 bg-gray-300 bg-opacity-85 rounded-lg w-48',
    container: 'flex flex-col text-left flex',
    separator: 'border-gray-500',
    heading: 'min-w-40 border-b border-gray-500 bg-gray-300 rounded-t-lg text-[1.1em] py-0.5 font-bold text-center text-gray-900',
    subheading: 'text-[0.8em] px-1 font-semibold text-gray-700',
    list: 'pl-4 text-[0.7em] list-disc list-outside text-gray-700', // Changed to list-outside
    listItem: 'px-1 pb-0.5 text-gray-700',
    paragraph: 'px-1 text-[0.7em] text-gray-700',
  };

  const stylesDark = {
    mainContainer: 'border text-white border-gray-500 bg-gray-800 bg-opacity-85 rounded-lg w-48',
    container: 'flex flex-col text-left flex',
    separator: 'border-gray-500',
    heading: 'min-w-40 border-b border-gray-500 bg-gray-900 rounded-t-lg text-[1.1em] font-bold text-center text-gray-200',
    subheading: 'text-[0.8em] px-1 font-semibold text-gray-200',
    list: 'pl-4 text-[0.7em] list-disc list-outside text-gray-200', // Changed to list-outside
    listItem: 'px-1 pb-0.5 text-gray-200', // Added padding-left
    paragraph: 'px-1 text-[0.7em] text-gray-200',
  };

  // Select the appropriate style object based on the theme
  const styles = theme === 'dark' ? stylesDark : stylesLight;

  if (container) {
    return (
      <div className={`${styles.mainContainer} ${className}`}>
        {children}
      </div>
    );
  }

  // Render the appropriate content based on the type
  const renderContent = () => {
    switch (type) {

      case 'mainContainer':
        return <div className={styles.mainContainer}></div>;
      
      case 'heading':
        return <h1 className={styles.heading}>{content}</h1>;

      case 'subheading':
        return <h2 className={styles.subheading}>{content}</h2>;

      case 'list':
        return (
          <ol className={styles.list}>
            {content.map((item, index) => (
              <li key={index} className={styles.listItem}>
                {item}
              </li>
            ))}
          </ol>
        );

      case 'paragraph':
        return <p className={styles.paragraph}>{content}</p>;

      case 'separator':
        return <hr className={styles.separator} />;

      default:
        return <p className={styles.paragraph}>{content}</p>;
    }
  };

  return <div className={`${styles.container} ${className}`}>{renderContent()}</div>;
};

export default FeatureContentElements;